export const isUSA = process.env.REACT_APP_DESTINATION === "USA";
